import { HttpMethod } from '@libs/core';
import { client } from '../../client';
import { CWEA_ENDPOINTS } from '../../constants';

export interface UploadedImage {
    cartId?: string;
    itemId: string;
    imageId?: string;
}

export interface UploadingImage extends UploadedImage {
    fileName: string;
    fileSize: string;
    formData: FormData;
}

export interface UploadImageReturn {
    imageId: string;
    uploadedDate: string;
}

export interface FetchImageResult {
    base64: string;
    contentType: string;
}

export async function fetchVetAuthImage(
    input?: Omit<UploadedImage, 'itemId'> | null
): Promise<FetchImageResult | null> {
    const url = CWEA_ENDPOINTS.cart.fetchVetAuthImage(input?.cartId, input?.imageId ?? '');

    return await client.cwea<FetchImageResult>(url, {
        method: HttpMethod.GET,
    });
}

export async function uploadVetAuthImage(input?: UploadingImage | null) {
    const url = CWEA_ENDPOINTS.cart.uploadVetAuthImage(input?.cartId, input?.itemId);

    return await client.cwea<UploadImageReturn>(url, {
        method: HttpMethod.POST,
        body: input?.formData,
    });
}
